export const SET_ALERT = '@alert/set-message';

export const setAlertMessage = (
  message,
  variant,
  redirect,
  asConfirm,
  yesAction,
  asOk,
  linkMessage,
  messageAfter,
  linkAction
) => {
  return dispatch => {
    dispatch({
      type: SET_ALERT,
      payload: message,
      payload1: variant,
      asConfirm: asConfirm,
      redirect: redirect,
      yesAction: yesAction,
      asOk: asOk,
      linkMessage: linkMessage,
      messageAfter: messageAfter,
      linkAction: linkAction
    });
  };
};
